<template>
  <div>
    <b-card no-body>
      <div id="listaRequests" style="display:block">
        <b-card-body>
          <div class="d-flex justify-content-between  flex-wrap">
            <!-- filter -->
            <b-form-group label-for="filterInput" class="mb-0">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Buscar" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </b-card-body>
        <b-card-body>
          <div class="d-flex justify-content-between  flex-wrap">
            <b-button variant="success" @click="$router.push({ name: 'admin_users_add' })">
              <feather-icon icon="FileIcon" class="mr-50" />
              <span class="align-middle">Nuevo</span>
            </b-button>
          </div>
        </b-card-body>
        <b-table responsive class="position-relative" :busy="isLoading" :per-page="perPage" :current-page="currentPage"
          :items="lstUsers" :small="true" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" @filtered="cPaginacion">
          <template #cell(actions)="data">
            <div>
              <div class="text-nowrap">
                <feather-icon :id="`${data.item.id}-edit-icon`" icon="EditIcon" class="cursor-pointer" size="16"
                  @click="$router.push({ name: 'admin_users_edit', params: { id: data.item.id } })" />
                <b-tooltip title="Editar usuario" class="cursor-pointer" :target="`${data.item.id}-edit-icon`" />
              </div>
            </div>
          </template>
          <template #cell(status)="data">
            <div class="text-nowrap">
              <div v-if="data.item.status">
                <b-badge pill variant="success">Activo</b-badge>
              </div>
              <div v-else>
                <b-badge pill variant="danger">Inactivo</b-badge>
              </div>
            </div>
          </template>
          <template #cell(clonned)="data">
            <div class="text-nowrap">
              <div v-if="data.item.clonned">
                <b-badge pill variant="success">Sí</b-badge>
              </div>
              <div v-else>
                <b-badge pill variant="danger">No</b-badge>
              </div>
            </div>
          </template>
          <template #cell(presented)="data">
            <div class="text-nowrap">
              <div v-if="data.item.presented">
                <b-badge pill variant="success">Sí</b-badge>
              </div>
              <div v-else>
                <b-badge pill variant="danger">No</b-badge>
              </div>
            </div>
          </template>
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
          <!-- page length -->
          <b-form-group label="Mostrar" label-cols="5" label-align="left" label-size="sm" label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1">
            <b-form-select id="perPageSelect2" v-model="perPage" size="sm" inline :options="pageOptions" />
          </b-form-group>
          <!-- pagination -->
          <div>
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number
              prev-class="prev-item" next-class="next-item" class="mb-0">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </div>
    </b-card>
  </div>
</template>

<script>

import axiosIns from '../../../../../../libs/axios'
import moment from 'moment'
import {
  BCard,
  BBadge,
  BTable,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BBadge,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BSpinner,
  },
  data() {
    return {
      isLoading: false,
      lstUsers: [],
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      small: true,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'user_id',
          label: 'ID SmartAgro',
          sortable: true,
        },
        {
          key: 'dni',
          label: 'DNI',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Nombre',
          sortable: true,
        },
        {
          key: 'clonned',
          label: 'Clonado?',
          sortable: true,
        },
        {
          key: 'clonned_date',
          label: 'Fecha clonación',
          sortable: true,
        },

        {
          key: 'presented',
          label: 'Presentado?',
          sortable: true,
        },
        {
          key: 'presented_date',
          label: 'Fecha presentación',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Estado',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Acciones',
        },
      ],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({
          text: f.label,
          value: f.key,
        }))
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const { id } = jsonUserData
      return id
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    async fetchData() {
      this.isLoading = true
      try {
        const response = await axiosIns.get('/nomina/boss_user/')
        const lstUsersTemp = response.data
        this.lstUsers = lstUsersTemp.map(row => {
          row.clonned_date = row.clonned_date ? moment(row.clonned_date).format('DD/MM/YY h:mm:ss A') : '-'
          row.presented_date = row.presented_date ? moment(row.presented_date).format('DD/MM/YY h:mm:ss A') : '-'
          return row
        })
        this.totalRows = this.lstUsers.length
        this.isLoading = false
      } catch (error) {
        console.error('Error:', error)
        this.isLoading = false
      }
    },
  },
}
</script>
